import { render, staticRenderFns } from "./AuthDropdown.vue?vue&type=template&id=37842622&"
import script from "./AuthDropdown.vue?vue&type=script&lang=js&"
export * from "./AuthDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports